import type { IIssue, ISiteSlim, SiteStatistics } from "App/Modules/Models";
import type { Moment } from "moment-timezone";

export type SiteIssuesInfo = {
    dtLatestIssue: Moment;
    numIssuesError: number;
    numIssuesWarning: number;
    numIssuesOther: number;

    numIssuesActive: number;
    numIssuesNew: number;
    issues: IIssue[];
};

export type SiteWithIssueInfo = ISiteSlim & SiteIssuesInfo;

export type SiteWithSurveillanceStateInfo = ISiteSlim & {
    surveillanceState: SiteSurveillanceState;
};

export enum SiteSurveillanceState {
    Armed,
    PartiallyArmed,
    Disarmed,
}

type SiteFilterColumns = {
    siteStateIsEnded: boolean;
};

export type CombinedSite = ISiteSlim & SiteStatistics & SiteIssuesInfo & SiteFilterColumns;
